module.exports = __webpack_public_path__ + "static/media/nat-2-large.41044cb0.jpg";